import RankTypes from './types';
import { Reducer } from 'redux';
import { MusicRankState, MusicRankDispatchAction } from './state';

const initialState : MusicRankState = {
    rank: ''
}

const RankReducer : Reducer<MusicRankState, MusicRankDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case RankTypes.FETCH_START:
                return state
            case RankTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default RankReducer;